// FormItem.tsx
import React from 'react';
import { Input, Label } from 'reactstrap';

interface FormItemProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: any
}

export const FormItem: React.FC<FormItemProps> = ({ label, value, onChange ,type = "text"}) => {
  return (
    <>
      <Label className="tabstext">{label}</Label>
      <Input  value={value} type={type} onChange={onChange} />
    </>
  );
};
